export interface ParkingDto {
  id: string;
  hasParking: boolean | null;
  parkingType: ParkingType | null;
  parkingAvailableSpaces: number | null;
  parkingSpacesAreTandem: boolean | null;
  parkingOtherDescription: string | null;
  parkingMonthlyChargePerSpace: number | null;
}

export enum ParkingType {
  CARPORT = 'Carport',
  GARAGE_ATTACHED = 'Garage Attached',
  GARAGE_DETACHED = 'Garage Detached',
  OFF_STREET = 'Off Street',
  ON_STREET = 'On Street',
  NONE = 'None',
}
